/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalListFlagReleasesPathParams = NonNullable<
  operations['internalListFlagReleases']['parameters']['path']
>;

export type InternalListFlagReleasesQueryParams = NonNullable<
  operations['internalListFlagReleases']['parameters']['query']
>;

export interface Input extends InternalListFlagReleasesPathParams {
  apiVersion?: string;
  query?: InternalListFlagReleasesQueryParams;
}

export async function internalListFlagReleases(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flag-releases', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
